import { CountryModel } from "./types";

// Mocked countries data (for GET /api/{companyId}/country/countries)
export const mockedCountries: CountryModel[] = [
  {
    id: 1,
    code: "PL",
    name: "Polska",
    nationId: 616,
  },
  {
    id: 2,
    code: "DE",
    name: "Niemcy",
    nationId: 276,
  },
  {
    id: 3,
    code: "FR",
    name: "Francja",
    nationId: 250,
  },
  {
    id: 4,
    code: "ES",
    name: "Hiszpania",
    nationId: 724,
  },
  {
    id: 5,
    code: "IT",
    name: "Włochy",
    nationId: 380,
  },
];
